<template>
        <SOSlotModal
            :modal-id="modalId"
            :modal-title="modalTitle"
            @close="back()"
        >
            <template v-slot:modal-body>
                <div class="over-y-auto" style="max-height: 70vh !important;">
                    <div v-if="searchData">
                        <div class="p-d-20">
                            <SOInputSearch
                                :id="'cari-transaksi'"
                                :placeholder="'Ketik Nama / ID Transaksi / No. Telp'"
                            />
                        </div>
                        <div class="">
                            <SOHeaderList
                                :title="'5 Transaksi'"
                                show-filter
                            />
                        </div>
                    </div>
                    <div class="bg-white" v-else>
                        <div class="p-t-12">
                            <span class="f-14 f-c-midgrey">
                                Ditemukan <span class="f-semi">2 transaksi</span> yang mungkin terkait 
                                dengan komplain ini. Pilih salah satu transaksi yang sesuai.
                            </span>
                        </div>
                    </div>
                    <div class="">
                        <CardTransaksi v-for="n in 5" :key="n" />
                    </div>
                </div>
            </template>
            <template v-slot:modal-footer>
                <div v-if="!searchData">
                    <div class="">
                        <label class="m-d-0 d-flex" @click="toggleCheck">
                            <SOCheckBox :is-checked="confirmSearch" />
                            <span class="f-14 m-l-12">Saya tidak menemukan transaksi yang saya cari</span>
                        </label>
                    </div>
                    <div v-if="confirmSearch">
                        <SOButton
                            :primary="true"
                            :full="true"
                            :text="'Cari lebih lanjut'"
                            :id="`search-more-transaction`"
                            @action="goSearch"
                        />
                    </div>
                </div>
            </template>
        </SOSlotModal>
</template>

<script>
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";
import CardTransaksi from "../components/CardTransaksi.vue";
import SOCheckBox from "@/so-components/global/ui/SOCheckBox";
import SOButton from "@/so-components/global/ui/SOButton";
import SOInputSearch from "@/so-components/global/input/SOInputSearch";
import SOHeaderList from "@/so-components/global/ui/SOHeaderList";

export default {
    name: "PilihTransakksiHapusModal",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOSlotModal,
        CardTransaksi,
        SOCheckBox,
        SOButton,
        SOInputSearch,
        SOHeaderList,
    },
    data() {
        return {
            modalId: 'modalpilihtransaksi',
            modalTitle: 'Pilih Transaksi',
            confirmSearch: false,
            searchData: false,
        }
    },
    methods: {
        open() {
            $("#" + this.modalId).modal("show");
        },
        closeModal() {
            $(`#${this.modalId}`).modal("hide");
        },
        async back() {
            this.closeModal();
        },
        toggleCheck() {
            this.confirmSearch = !this.confirmSearch;
        },
        goSearch() {
            this.searchData = true;
        }
    },
}
</script>